import React, { useEffect, useState, useRef } from 'react';
import Axios from 'axios';
import {
	getCurrencySymbol,
	loadState,
	loadStateSession,
} from '../../../../FlyfishComponents/flyfishutils/utils';
import styled from 'styled-components';
import {
	AIIcon,
	LoaderGif,
} from '../../../../FlyfishComponents/flyfishIcons/icons';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import Modal from '../../../../FlyfishComponents/Modal';
import Button from '../../../../FlyfishComponents/Button';
import EcomStarRating from '../EcomStarRating';
import EcomStyleAdvisor from '../EcomStyleAdvisor';
import {
	BackwardWelCarousel,
	ForwardWelCarousel,
	SendIconButton,
} from '../../../../../Components/FeatureComponents/Buttons/IconButton/Icons';
import Slider from 'react-slick';
import EcomCarousel from './EcomCarousel';
import StyleAdvisorCarousel from './StyleAdvisorCarousel';
const MonacoModalContainer = styled.div`
	width: 100%;
	overflow-y: auto;
	height: calc(100vh - 150px);
	padding-top: 45px;
	@media (max-width: 1000px) {
		margin-left: -2px;
		height: calc(100vh - 175px);
	}

	& .product-addition-confirmation {
		@media (max-width: 600px) {
			justify-content: center !important;
		}
		& > .modal-container-bot {
			max-width: 534px;
			height: unset;
			display: flex;
			align-items: center;
			padding: 28px 40px 40px 40px;

			& > .body1 {
				font-family: var(--fontFamily);
				font-size: 18px;
				text-align: center;
				display: flex;
				flex-direction: column;
				gap: 20px;
				overflow: hidden;
				& > .custom-button {
					& > button {
						height: 50px;
						border: 1px solid var(--selectedColor);
						color: var(--selectedColor);
						width: 88px;
						border-radius: 10px;
						background-color: #fff;
						& > .custom-button-body {
							color: var(--selectedColor);
						}
					}
				}
			}
		}
	}
	> .product-addition-confirmation.ecom {
		& > .modal-container-bot {
			border-radius: 10px;
		}
	}
	> .product-addition-confirmation.ff-zoom-product.modal-overlay-bot {
		& > .modal-container-bot {
			height: 89%;
			border-radius: 10px;
			position: relative;
			overflow: hidden;
			width: 74%;

			& > .body1 {
				height: 100%;
				justify-content: center;
			}
			@media (max-width: 600px) {
				height: initial !important;
				& > .body1 {
					width: 100%;
				}
			}
			> header {
				> .top-close {
					position: absolute;
					top: 0px;
					right: 0px;
				}
			}
		}
	}
`;
const ProductContainer = styled.div`
	background-color: #fff;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	font-family: var(--fontFamily);
	@media (max-width: 1000px) {
		padding: 10px 0%;
	}
	&.ff-ecom-monaco {
		padding-top: 50px;
		@media (max-width: 1000px) {
			padding-top: 37px;
		}
		.ff-cart-page {
			width: 194px;
		}
		.product-image-display {
			p {
				display: flex;
				font-size: 14px;
				justify-content: center;
				align-items: center;
				svg {
					margin-right: 4px;
				}
			}
		}
		> div {
			&:nth-of-type(1) {
				display: flex;
				max-width: unset;
			}
		}
	}
	> div {
		&:nth-of-type(1) {
			display: flex;
			max-width: 1300px;
			justify-content: center;
			margin-bottom: 80px;
			@media (max-width: 1000px) {
				flex-direction: column;
				max-width: 99vw;
			}
		}
		&:nth-of-type(2) {
			background-color: #f7f7f7;
			padding: 20px;
			margin-top: 25px;
			> div {
				&:nth-of-type(1) {
					font-weight: 500;
					@media (max-width: 1000px) {
						text-align: center;
					}
				}
				&:nth-of-type(2) {
					margin-top: 7px;
					@media (max-width: 1000px) {
						text-align: center;
					}
				}
			}
		}
	}
`;
const ProductImageDisplay = styled.div`
	margin-right: 20px;
	display: flex;
	flex-direction: row;
	width: 30%;
	position: relative;
	p {
		position: absolute;
		top: -36px;
		display: none;
	}
	.fade-out {
		opacity: 0 !important;
	}

	.fade-in {
		opacity: 1 !important;
	}
	.ff-selected-image {
		opacity: 1;
		transition: opacity 0.5s ease-in-out;
	}

	@media (max-width: 1000px) {
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.ff-selected-image {
	}
	> div {
		> img {
			width: 97%;
			height: 100%;
		}
	}

	> div {
		&:nth-of-type(2) {
			margin-left: 25px;
			width: 100%;
			display: flex;
			justify-content: flex-start;
			align-items: flex-start;
			border-radius: 10px;
			flex-direction: column;
			> img {
				height: auto;
				width: 100%;
				border-radius: 10px;
			}
		}
		&:nth-of-type(1) {
			@media (max-width: 1000px) {
				margin-left: 30px;
				width: 100%;
			}
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-start;
			max-width: 300px;
			flex-direction: column;
			> div {
				display: flex;
				width: 44px;
				justify-content: center;
				align-items: center;
				margin-top: 0px;
				border-radius: 10px;
				cursor: pointer;
				margin-bottom: 4px;
				> img {
					width: 100%;
					object-fit: contain;
					height: auto;
					border-radius: 10px;
				}
			}
		}
	}
`;
const ProductDescription = styled.div`
	margin-left: 0px;
	width: 35%;
	margin-right: 20px;
	font-family: var(--fontFamily);
	& > div {
		width: 100%;
	}

	@media (max-width: 1000px) {
		width: 90%;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		margin-top: 30px;
		margin-left: 20px;
		> div {
			&:nth-of-type(2) {
				> .ff-chatbot-body2 {
					font-weight: 600;
				}
			}
		}
	}

	.ff-action-btn {
		border: 1px solid var(--colorScale-3);
		color: #fff;
		margin-top: 20px;
		letter-spacing: 0.5px;
		font-family: var(--fontFamily);
		cursor: pointer;
		border-radius: 10px;
		background-color: transparent;
		color: var(--colorScale-3);
		font-weight: 500;
		padding: 10px 16px;
	}
	.ff-monaco-recommendation {
		padding: 25px;
		margin-bottom: 20px;
		border-radius: 10px;
		background-color: var(--colorScale-9);
		padding-top: 16px;
		position: relative;
		> svg {
			position: absolute;
			right: 10px;
			top: 10px;
		}
		@media (min-width: 768px) and (max-width: 820px) {
			width: 60%;
		}
		& > .animation-character {
			color: var(--black-10);
			overflow: hidden;
			animation: overlay-animation 0.5s ease-in-out infinite alternate;
		}
		@keyframes overlay-animation {
			0% {
				opacity: 0.5;
			}
			100% {
				opacity: 1;
			}
		}
		&.mobile {
			margin-top: 30px;
			margin-bottom: 0px;
		}
		> div {
			&:nth-of-type(1) {
				font-weight: bold;
				font-size: 18px;
			}
			&:nth-of-type(2) {
				font-size: 14px !important;
				margin-top: 7px;
			}
		}
	}
	.ff-out-stock {
		background-color: transparent;
		color: var(--selectedColor);
		border: 1px solid var(--selectedColor);
		opacity: 0.5;
		cursor: not-allowed;
	}
	.ff-chatbot-h6 {
		text-transform: capitalize;
		margin-top: 3px;
		margin-bottom: 3px;
		font-weight: bold;
	}
	.ff-description {
		font-size: 14px;
		line-height: 21px;
	}
`;
const ProductVariants = styled.div`
	> .choices {
		& > div {
			& > .title {
				margin-top: 16px;
				margin-bottom: 8px;
				font-weight: 600;
			}
			& > .MuiFormGroup-root {
				display: flex;
				cursor: pointer;
				display: -webkit-box;

				& > label {
					margin-right: 8px;
					margin-bottom: 8px;
					margin-left: unset;
					border-radius: 5px;
					&.active {
						border: 1px solid var(--selectedColor);
					}
					padding: 4px 12px;
					text-transform: capitalize;
					border: ${(props: any) => `solid 1px #A5A5A5`};

					& > span:first-child {
						display: none;
					}
				}
			}
		}
	}
`;
const MonacoLoader = styled.div`
	height: 86vh;
	background-color: #fff;
	width: 100%;
`;
const ProductQuantity = styled.div`
	display: flex;
	align-items: center;
	border: 1px solid #b2b1b1;
	width: 84px;
	height: 28px;
	border-radius: 7px;
	.ff-quantity-button {
		background-color: transparent;
		color: var(--selectedColor);
		border: none;
		text-align: center;
		text-decoration: none;
		display: inline-block;
		font-size: 16px;
		cursor: pointer;
	}

	.ff-quantity-display {
		width: 28px;
		text-align: center;
		font-size: 14px;
		margin: 0 8px;
		border: none;
	}
`;
type Props = {
	tenantId;
	token;
	secondAPI?;
	data?;
	closeAPI?;
	callOnce?;
	conversationId;
	products?;
	reasonData;
	ecom;
	setSelectedProductData;
	handleStyleAdvisor;
	styleAdvisor;
	styleAdvisorCache;
	getTitleMessage?;
	handleSubmit?;
	category?;
	onClickStyleAdvisor;
	selectedProductID;
	modalClassName?;
	onClose?;
	theme?;
	enableStyleAdvisor;
	advisorTitle;
};

const EcomCartItem = ({
	tenantId,
	token,
	reasonData,
	conversationId,
	setSelectedProductData,
	handleStyleAdvisor,
	styleAdvisor,
	category,
	styleAdvisorCache,
	getTitleMessage,
	handleSubmit,
	onClickStyleAdvisor,
	selectedProductID,
	modalClassName,
	onClose,
	theme,
	enableStyleAdvisor,
	advisorTitle
}: // botId,
	Props) => {
	const [productImage, setProductImage] = useState([]);
	const [selectedImageIndex, setSelectedImageIndex] = useState(0);
	const [selectedImage, setSelectedImage] = useState('');
	const [choices, setChoices] = useState([]);
	const [response, setResponse] = useState<any>(null);
	const [selectedVariant, setSelectedVariant] = useState<any>();
	const [sku, setSku] = useState('');
	const [quantity, setQuantity] = useState(1);
	const [reasonQuery, setReasonQuery] = useState('');
	const [reasonDesc, setReasonDesc] = useState('');
	const [loader, setLoader] = useState(false);
	const [inventory, setInventory] = useState(-1);
	const [taxable, setTaxable] = useState(false);
	const [selectedVariantIndex, setSelectedVariantIndex] = useState(0);
	const [selectedOptions, setSelectedOptions] = useState([]);
	const [productAdded, setProductAdded] = useState(false);
	const [isFading, setIsFading] = useState(false);
	const [zoomEnable, setZoomEnable] = useState(false);
	const [styleCache, setStyleCache] = useState<any>();
	const [mobile, setMobile] = useState(false);
	const slider = React.useRef<any>();

	const next = () => {
		slider.current.slickNext();
	};
	const previous = () => {
		slider.current.slickPrev();
	};

	const settings = {
		dots: false,
		infinite: false,
		slidesToScroll: 1,
		slidesToShow: 3,
		prevArrow: (
			<div
				className='ff-back-wel'
				onClick={() => {
					previous();
				}}
			>
				<BackwardWelCarousel
					className='ff-back-wel'
					width='31px'
					height='31px'
					filledColor={'#000'}
					fill={'#000'}
				/>
			</div>
		),
		nextArrow: (
			<div
				onClick={() => {
					next();
				}}
			>
				<ForwardWelCarousel
					className='ff-next-wel'
					width='24px'
					height='24px'
					filledColor={'#000'}
					fill={'#000'}
				/>
			</div>
		),
	};

	useEffect(() => {
		if (window.innerWidth < 1000 || window.screen.width < 1000) {
			setMobile(true);
		} else {
			setMobile(false);
		}
		window.addEventListener(
			'resize',
			function (event) {
				if (window.innerWidth < 1000 || window.screen.width < 1000) {
					setMobile(true);
				} else {
					setMobile(false);
				}
			},
			true
		);
	});
	useEffect(() => {
		setLoader(true);
		console.log(styleAdvisorCache);
		let advisor = styleAdvisorCache.filter((item) => {
			return item.id === loadStateSession('FF-productID');
		});
		if (advisor && advisor.length > 0) {
			setStyleCache(advisor[0].data);
		} else {
			handleStyleAdvisor(
				loadStateSession('FF-productID'),
				loadStateSession('FF-productName')
			);
			setStyleCache('');
		}

		Axios.get(
			`${window['BASE_URL']
			}/shop/${tenantId}/product?productId=${loadStateSession(
				'FF-productID'
			)}&country=IN`,
			{
				headers: {
					'x-tenant-id': tenantId,
					Authorization: `Bearer ${token}`,
				},
			}
		).then((resp: any) => {
			let response = resp.data.response.data;
			setResponse(resp.data.response.data);
			getTitleMessage(resp.data.response.data.title);
			setSelectedProductData({
				productID: resp.data.response.data.productId,
				productName: resp.data.response.data.title,
			});
			setProductImage(response.images);
			setSelectedImage(response.images[0]);
			setChoices(response.choices);
			setLoader(false);
			setSelectedVariant(response.variants && response.variants[0]);
			setSelectedOptions(response.variants && response.variants[0].options);
			setLoader(false);
		});
	}, [selectedProductID]);

	useEffect(() => {
		let reason =
			reasonData &&
			reasonData.data.metaData.products.filter((item) => {
				return item.product_id == loadStateSession('FF-productID');
			});
		if (reason && reason[0]) {
			setReasonDesc(reason[0].reason);
			setReasonQuery(reason[0].reason_query);
		}
	}, [reasonData]);

	const findSelectedVariant = (selectedOptions) => {
		const selectedVariantIndex = response.variants.findIndex((variant) =>
			selectedOptions.every((selectedOption) =>
				variant.options.some(
					(variantOption) =>
						variantOption.type === selectedOption.type &&
						variantOption.value === selectedOption.value
				)
			)
		);

		const selectedVariant = response.variants[selectedVariantIndex];
		setSelectedVariantIndex(selectedVariantIndex);
		return selectedVariant;
	};

	const handleChange = (event, choiceIndex) => {
		const { value } = event.target;

		const updatedSelectedOptions = [...selectedOptions];
		updatedSelectedOptions[choiceIndex] = {
			type: choices[choiceIndex].type,
			value,
		};
		setSelectedOptions(updatedSelectedOptions);

		// Call a function to find the variant based on selectedOptions
		const selectedVariant = findSelectedVariant(updatedSelectedOptions);

		if (selectedVariant) {
			setSelectedVariant(selectedVariant);
			// if (quantity > selectedVariant.quantity) {
			// 	setQuantityError(true);
			// } else {
			// 	setQuantityError(false);
			// }
			// Perform actions with selected variant
		} else {
			console.log('Variant not found for selected options');
		}
	};

	const handleIncrement = () => {
		setQuantity(quantity + 1);
	};

	const handleDecrement = () => {
		if (quantity > 1) {
			setQuantity(quantity - 1);
		}
	};
	const handleImageChange = (item, index) => {
		setIsFading(true);

		// Change the image source after a delay to allow fade-out effect
		setTimeout(() => {
			setSelectedImageIndex(index);
			setSelectedImage(item);
			setIsFading(false);
		}, 500);
	};
	return (
		<>
			<MonacoModalContainer className='ecom-modal-container'>
				{loader ? (
					<MonacoLoader>
						<div className='ff-loader-cnt'>
							<LoaderGif />
						</div>
					</MonacoLoader>
				) : (
					<div>
						<ProductContainer
							className={`product-container ${modalClassName ? modalClassName : ''
								}`}
						>
							<div>
								{mobile ? (
									<EcomCarousel
										productImage={productImage}
										handleZoom={(image) => {
											setZoomEnable(true);
											setSelectedImage(image);
										}}
										onClose={onClose}
										showBack={true}
										showBacktoConv={theme === 'E-commerce Chat' ? true : false}
									/>
								) : (
									<ProductImageDisplay className='product-image-display'>
										{theme === 'E-commerce Chat' ? (
											<p
												onClick={() => {
													onClose();
												}}
												style={{ cursor: 'pointer' }}
											>
												<svg
													xmlns='http://www.w3.org/2000/svg'
													width='24'
													height='24'
													viewBox='0 0 24 24'
												>
													<g>
														<path
															fill='none'
															d='M312 379.968h24v24h-24z'
															transform='translate(-312 -379.968)'
														/>
														<path
															fill='var(--selectedColor)'
															d='M332 390.968h-12.17l5.59-5.59-1.42-1.41-8 8 8 8 1.41-1.41-5.58-5.59H332z'
															transform='translate(-312 -379.968)'
														/>
													</g>
												</svg>
												Back to Conversations{' '}
											</p>
										) : null}

										<div>
											{productImage &&
												productImage.map((item, index) => {
													return (
														<div
															style={{
																border:
																	selectedImageIndex == index
																		? '1px solid var(--selectedColor)'
																		: '1px solid #c1c1c1',
															}}
														>
															<img
																onClick={() => {
																	handleImageChange(item, index);
																}}
																src={item}
															/>
														</div>
													);
												})}
										</div>
										<div>
											{!mobile && (
												<img
													className={`ff-selected-image ff-ecom-image ${isFading ? 'fade-out' : 'fade-in'
														}`}
													onAnimationEnd={() => setIsFading(false)}
													src={productImage && selectedImage}
													onClick={() => {
														setZoomEnable(true);
													}}
												/>
											)}
										</div>
									</ProductImageDisplay>
								)}

								<ProductDescription className='product-description'>
									<div>
										{!mobile && category !== 'You may also like' && (
											<div className='ff-monaco-recommendation'>
												<AIIcon />
												<div className='ff-chatbot-body1'>{`Why do we recommend ${response &&
													response.title}?`}</div>
												{reasonDesc ? (
													<div className='ff-chatbot-body2 '>{reasonDesc}</div>
												) : (
													<div className='ff-chatbot-body2 animation-character'>
														▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆
														▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆
														▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆ ▆▆▆▆▆▆▆▆▆▆▆▆▆
													</div>
												)}
											</div>
										)}
										<div>
											<div
												className='ff-chatbot-caption'
												style={{ textTransform: 'uppercase' }}
											>
												{response && response.vendor}
											</div>
											<div className='ff-chatbot-h6 '>
												{response && response.title}
											</div>
											{sku && (
												<div className='ff-chatbot-caption'>SKU: {sku}</div>
											)}
										</div>
										{response &&
											response.rating &&
											parseInt(response.rating) > 0 && (
												<EcomStarRating
													userRating={parseInt(response.rating)}
												/>
											)}

										<div style={{ marginTop: '7px' }}>
											{selectedVariant &&
												selectedVariant.currency.length > 0 &&
												parseInt(selectedVariant.price) > 0 && (
													<div
														className='ff-chatbot-h3'
														style={{ color: 'var(--selectedColor)' }}
													>
														<sup
															style={{ fontSize: '16px', marginRight: '4px' }}
														>
															{getCurrencySymbol(
																selectedVariant && selectedVariant.currency
															)}
														</sup>
														{selectedVariant && selectedVariant.price}
													</div>
												)}

											{taxable && (
												<div
													className='ff-chatbot-caption tax'
													style={{ marginTop: '5px' }}
												>
													Tax included:{' '}
													<a
														target='_blank'
														href='https://www.apm.mc/policies/shipping-policy'
													>
														Shipping calculated
													</a>{' '}
													at checkout
												</div>
											)}
										</div>

										<div
											className='ff-chatbot-body2'
											style={{
												color: '#000',
												marginTop: '15px',
												marginBottom: '5px',
												fontWeight: '600',
											}}
										>
											Quantity
										</div>
										<ProductQuantity>
											<button
												className='ff-quantity-button'
												onClick={handleDecrement}
											>
												-
											</button>
											<input
												type='text'
												value={quantity}
												readOnly
												className='ff-quantity-display'
											/>
											<button
												className='ff-quantity-button'
												onClick={handleIncrement}
												disabled={inventory <= quantity ? false : true}
											>
												+
											</button>
										</ProductQuantity>
										{response && response.choices.length > 0 && (
											<ProductVariants>
												{/* <div className='ff-chatbot-body2 '>{type}</div> */}
												<div className='choices'>
													{choices.map((choice, choiceIndex) => (
														<>
															<div
																key={choice.type + choiceIndex}
																className={`group ${choiceIndex}`}
															>
																<div className='ff-chatbot-body2 title'>
																	{choice.type}
																</div>
																<RadioGroup
																	aria-label={choice.type}
																	name={choice.type}
																	value={
																		(selectedOptions[choiceIndex] &&
																			selectedOptions[choiceIndex].value) ||
																		''
																	}
																	onChange={(event) =>
																		handleChange(event, choiceIndex)
																	}
																>
																	{choice.values.map((value, valueIndex) => {
																		const isSelected =
																			selectedOptions[choiceIndex] &&
																			selectedOptions[choiceIndex].value ===
																			value;
																		//let value1 =value
																		// choice.type.toLowerCase() === 'size'
																		// 	? value.slice(0, 1)
																		//value;
																		return (
																			<FormControlLabel
																				className={isSelected ? 'active' : ''}
																				key={valueIndex}
																				value={value}
																				control={<Radio />}
																				label={value}
																			/>
																		);
																	})}
																</RadioGroup>
															</div>
														</>
													))}
												</div>
											</ProductVariants>
										)}

										{/* {
						inventory === 0?
						<button className='ff-action-btn ff-out-stock'>Out of Stock</button>: */}
										<div>
											<button
												className='ff-action-btn'
												onClick={() => {
													if (loadState('ff_shopify_cook') !== undefined) {
														let payload: any = {
															conversationId: conversationId,
															productId: loadStateSession('FF-productID'),
															quantity: quantity,
															variantId: selectedVariant && selectedVariant.id,
															shopifyToken: loadState(
																'ff_shopify_cook'
															).replace(',', ';'),
														};
														fetch(window['BASE_URL'] + '/shop/product/cart', {
															method: 'POST',
															headers: {
																'Content-Type': 'application/json',
																'x-tenant-id': tenantId,
																Authorization: `Bearer ${token}`,
															},
															body: JSON.stringify(payload),
														})
															.then((data) => data.json())
															.then((response) => {
																setProductAdded(true);
															})
															.catch((err) => {
																setProductAdded(false);
															});
													} else {
														// createCart(
														// 	variantId,
														// 	quantity,
														// 	'genericcart',
														// 	loadStateSession('FF-productID')
														// );
													}
												}}
											>
												Add to Cart
											</button>
											<button
												className='ff-action-btn'
												style={{ marginLeft: '5px' }}
											>
												View Customer Reviews
											</button>
											{mobile && (
												<div
													className={`ff-monaco-recommendation ${mobile ? 'mobile' : ''
														}`}
												>
													<AIIcon />
													<div className='ff-chatbot-body1'>{`Why do we recommend ${response &&
														response.title}?`}</div>

													{reasonDesc ? (
														<div className='ff-chatbot-body2 '>
															{reasonDesc}
														</div>
													) : (
														<div className='ff-chatbot-body2 animation-character'>
															▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆
															▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆
															▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆
															▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆ ▆▆▆▆▆▆▆▆▆▆▆▆▆
														</div>
													)}
												</div>
											)}
										</div>
									</div>

									{/* 
					 } */}
									{response && response.descriptionHtml.length ? (
										<div>
											<div
												className='ff-chatbot-body2 '
												style={{
													marginTop: '25px',
													marginBottom: '7px',
													fontWeight: 'bold',
												}}
											>
												Product Details
											</div>
											<div
												dangerouslySetInnerHTML={{
													__html: response && response.descriptionHtml,
												}}
												className='ff-description'
											></div>
										</div>
									) : null}
								</ProductDescription>
								{mobile && enableStyleAdvisor === 'true' ? (
									<StyleAdvisorCarousel
										handleSubmit={handleSubmit}
										onClickStyleAdvisor={onClickStyleAdvisor}
										data={
											styleCache && styleCache.length > 0
												? styleCache
												: styleAdvisor
										}
										advisorTitle={advisorTitle}
									/>
								) : (
									enableStyleAdvisor === 'true' ?
										<EcomStyleAdvisor
											onClose={onClose}
											onClickStyleAdvisor={onClickStyleAdvisor}
											handleSubmit={handleSubmit}
											customClassName='ff-cart-page ff-ecom-monaco-cart-page'
											data={
												styleCache && styleCache.length > 0
													? styleCache
													: styleAdvisor
											}
											styleAdvisorCache={styleAdvisorCache}
											advisorTitle={advisorTitle}
										/>
										:
										null
								)}
							</div>
						</ProductContainer>
					</div>
				)}
				{zoomEnable && (
					<Modal
						className='product-addition-confirmation ff-zoom-product'
						footerNotReq={true}
						onClose={() => setZoomEnable(false)}
						headerCloseBtn={true}
						headerCloseBtnIcon={
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='29.255'
								height='29.25'
								viewBox='0 0 29.255 29.25'
							>
								<g
									id='Icon_ion-ios-close-outline'
									data-name='Icon ion-ios-close-outline'
									transform='translate(-3.372 -3.375)'
								>
									<path
										id='Path_20510'
										data-name='Path 20510'
										d='M28.343,7.657a14.627,14.627,0,1,0,0,20.686,14.632,14.632,0,0,0,0-20.686Zm-.865,19.821a13.4,13.4,0,1,1,0-18.956A13.423,13.423,0,0,1,27.478,27.478Z'
									/>
									<path
										id='Path_20511'
										data-name='Path 20511'
										d='M23.92,11.25l-5.934,5.92L12.08,11.278l-.83.83L17.156,18,11.25,23.892l.83.83,5.906-5.892,5.934,5.92.83-.83L18.816,18l5.934-5.92Z'
									/>
								</g>
							</svg>
						}
						actionButtons={<></>}
					>
						<img src={selectedImage} style={{ maxHeight: '100%' }} />
					</Modal>
				)}
				{productAdded && (
					<Modal
						className='product-addition-confirmation ecom'
						footerNotReq={true}
						onClose={() => setProductAdded(false)}
						headerCloseBtnIcon={
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='29.255'
								height='29.25'
								viewBox='0 0 29.255 29.25'
							>
								<g
									id='Icon_ion-ios-close-outline'
									data-name='Icon ion-ios-close-outline'
									transform='translate(-3.372 -3.375)'
								>
									<path
										id='Path_20510'
										data-name='Path 20510'
										d='M28.343,7.657a14.627,14.627,0,1,0,0,20.686,14.632,14.632,0,0,0,0-20.686Zm-.865,19.821a13.4,13.4,0,1,1,0-18.956A13.423,13.423,0,0,1,27.478,27.478Z'
									/>
									<path
										id='Path_20511'
										data-name='Path 20511'
										d='M23.92,11.25l-5.934,5.92L12.08,11.278l-.83.83L17.156,18,11.25,23.892l.83.83,5.906-5.892,5.934,5.92.83-.83L18.816,18l5.934-5.92Z'
									/>
								</g>
							</svg>
						}
						actionButtons={<></>}
					>
						<>
							<div>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									width='53'
									height='53'
									viewBox='0 0 53 53'
								>
									<g
										id='Group_35153'
										data-name='Group 35153'
										transform='translate(-7377.454 -12498.453)'
									>
										<g
											id='Ellipse_1354'
											data-name='Ellipse 1354'
											transform='translate(7377.454 12498.453)'
											fill='#fff'
											stroke='var(--selectedColor)'
											stroke-width='2'
										>
											<circle cx='26.5' cy='26.5' r='26.5' stroke='none' />
											<circle cx='26.5' cy='26.5' r='25.5' fill='none' />
										</g>
										<path
											id='Path_20512'
											data-name='Path 20512'
											d='M7656.977,12221.105l9.249,8.637,15.494-16.93'
											transform='translate(-265.153 303.754)'
											fill='none'
											stroke='var(--selectedColor)'
											stroke-linecap='round'
											stroke-width='5'
										/>
									</g>
								</svg>
							</div>
							<div>
								{(response && response.title) ?? 'Product'} has been added to
								your bag
							</div>
							<Button variant='outlined' onClick={() => setProductAdded(false)}>
								OK
							</Button>
						</>
					</Modal>
				)}

				{/* {ecom} */}
			</MonacoModalContainer>
		</>
	);
};

export default EcomCartItem;
